import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearContenidoFilters } from "../utils/contenidoFiltersStorage";

export default function ContenidoFiltersCleaner() {
  const location = useLocation();

  useEffect(() => {
    const isInsideContenido = location.pathname.startsWith("/rrhh/contenido");

    if (!isInsideContenido) {
      clearContenidoFilters();
    }
  }, [location.pathname]);

  return null;
}